import React, { FC, useState } from "react";
import {
  Box,
  Chip,
  Grid,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormChipEmailField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const [inputValue, setInputValue] = useState("");

  const emails: string[] = Array.isArray(props.value)
    ? props.value
    : [];

  // ✅ Email Validation
  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // ✅ Add email chip
  const handleAddEmail = () => {
    const value = inputValue.trim();

    if (!value) return;

    if (!isValidEmail(value)) {
      return; // invalid email ignore or show error
    }

    if (emails.includes(value)) {
      setInputValue("");
      return;
    }

    if (props.onChange) {
      props.onChange({
        target: {
          id: props.id,
          value: [...emails, value],
        },
      });
    }

    setInputValue("");
  };

  // ✅ Remove chip
  const handleDelete = (email: string) => {
    const updated = emails.filter((e) => e !== email);

    if (props.onChange) {
      props.onChange({
        target: {
          id: props.id,
          value: updated,
        },
      });
    }
  };

  // ✅ Handle key press
  const handleKeyDown = (e: any) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      handleAddEmail();
    }

    // remove last chip on backspace
    if (e.key === "Backspace" && !inputValue && emails.length) {
      handleDelete(emails[emails.length - 1]);
    }
  };

  const renderInput = () => (
    <TextField
      fullWidth
      value={inputValue}
      placeholder={props.placeholder || "Enter email"}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleAddEmail}
      variant="outlined"
      InputProps={{
        sx: {
          background: "#fff",
          ...props?.InputProps?.sx,
        },
      }}
    />
  );

  return (
    <>
      {props?.label && (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{ ...props?.GridFieldStyle }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "left",
              }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red" }}>*</span>
              )}
            </InputLabel>
          </Tooltip>

          <Box
            sx={{
            //   border: "1px solid #ccc",
              borderRadius: "6px",
            //   padding: "6px",
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              minHeight: "45px",
              alignItems: "center",
            //   background: "#fff",
            }}
          >
            {/* Chips */}
            {emails.map((email, index) => (
              <Chip
                key={index}
                label={email}
                onDelete={() => handleDelete(email)}
                size="small"
              />
            ))}

            {/* Input */}
            <Box sx={{ flexGrow: 1, minWidth: "120px" }}>
              {renderInput()}
            </Box>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default FormChipEmailField;